import styled from 'styled-components'

export const ControlContainer = styled.div`
	display: flex;
	align-items: center;
	pointer-events: none;
	margin: -6px -6px;
`
